import Storefront from './storefront';
import { productGet } from './storefront/queries';

// Define the utility library
const ShopifyUtil = (() => {
  const storefront = Storefront.getInstance();
  // Main function to fetch product data
  const getProductData = async (productId) => {
    const lineProductGid = `gid://shopify/Product/${productId}`;
    const response = await storefront.request({
      query: productGet,
      variables: {
        id: lineProductGid,
      },
    });

    if (!response.data) {
      // eslint-disable-next-line no-console
      console.error('cart-item.js: Storefront API request failed', response);
      return {};
    }

    return response.data;
  };

  // Helper function to find a variant by ID
  const findVariantById = (variants, id) => {
    const gid = id.includes('gid:') ? id : `gid://shopify/ProductVariant/${id}`;
    return variants?.find((variant) => variant.node.id === gid)?.node || null;
  };

  // Function to process the product data and find the appropriate variant
  const processLineProductData = (lineProductData, variantId) => {
    const variantData = findVariantById(lineProductData.product?.variants?.edges, variantId);
    return variantData;
  };

  // Function to get product pricing information
  const getProductPricing = async (productId) => {
    const productData = await getProductData(productId);

    if (!productData.product) {
      return {};
    }

    const variants = productData.product.variants.edges.map((edge) => ({
      id: edge.node.id,
      handle: edge.node.handle,
      price: edge.node.price,
      compareAtPrice: edge.node.compareAtPrice,
    }));

    return {
      id: productData.product.id,
      handle: productData.product.handle,
      priceRange: productData.product.priceRange,
      variants,
    };
  };

  // Attach functions to the window object
  return {
    getProductData,
    getProductPricing,
    processLineProductData,
    findVariantById,
  };
})();

// Make the ShopifyUtil globally accessible
window.ShopifyUtil = ShopifyUtil;

export default ShopifyUtil;
